import moment from 'moment'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Colors } from '~/styles'
import { SET_USER_PROFILE_LOCATION } from '~/redux/actions'
import { DashboardTrafficInformationAPI } from '~/api'
import { GetDurationMinutes, ConvertLocalTimeGet } from '~/utils'

const useHooks = () => {
  const dispatch = useDispatch()

  const appSize = useSelector((state) => state.appReducer)
  const { Location } = useSelector((state) => state.usersProfileReducer)
  const { UserLocations } = useSelector((state) => state.usersLoginReducer)

  const [isLoading, setIsLoading] = useState(false)
  const [dataNextPlan, setDataNextPlan] = useState([])
  const [dataOngoingVessel, setDataOngoingVessel] = useState([])

  const appHeight = appSize.height - 110 > 455 ? appSize.height - 110 : 455
  const currentDate = moment().format('MMMM YYYY')
  const refreshInterval = 15 // in minutes

  const handleSetLocation = (value) => {
    const valueLocation = UserLocations.find((e) => e.LocationDescription === value)

    dispatch({
      type: SET_USER_PROFILE_LOCATION,
      payload: valueLocation,
    })
  }

  const convertLocalTime = (date, format) => {
    if (date) {
      return ConvertLocalTimeGet(Location.LocationDescription, date, format)
    }
    return '-'
  }

  const convertDurationLocalTime = (start, end) => {
    if (start && end) {
      const startLocalTime = ConvertLocalTimeGet(Location.LocationDescription, start, 'MM-DD-YYYY HH:mm')
      const endLocalTime = ConvertLocalTimeGet(Location.LocationDescription, end, 'MM-DD-YYYY HH:mm')
      return GetDurationMinutes(new Date(startLocalTime), new Date(endLocalTime), 0).replace('Minutes', 'Mins')
    }
    return null
  }

  const handleMapDataVesselTraffic = (data, type) => {
    // Return an empty array if data is not valid
    if (!data || !Array.isArray(data)) {
      return []
    }
    return data.map((item) => {
        return {
        id: item.id,
        qty: item.quantity,
        uom: item.uom,
        sr_no: item.sr_no,
        jetty: item.jetty_name,
        client: item.customer_name,
        status: type === 'next_plan' ? item.plan_name : item.vessel_color_status,
        product: item.product,
        all_fast: `${convertLocalTime(item.all_fast, 'DD MMM YY')} | ${convertLocalTime(item.all_fast, 'HH:mm')}`,
        cast_off: `${convertLocalTime(item.cast_off, 'DD MMM YY')} | ${convertLocalTime(item.cast_off, 'HH:mm')}`,
        activity: item.activity_name,
        vessel_name: item.vessel_name,
        duration: convertDurationLocalTime(item.all_fast, item.cast_off),
        vessel_color_status: item.vessel_color_status || Colors.white,
      }
    })
  }

  const fetchVesselTrafficData = async () => {
    try {
      setIsLoading(true)
      const payload = {
        skip: 0,
        take: 1000,
        filters: Location && Location.LocationID
          ? `[{ "type": "number", "value": "${Location.LocationID}", "field": "location_id" }]`
          : '[]',
      }

      const response = await DashboardTrafficInformationAPI.GetDashboardTrafficInformation(payload)

      if (!response || !response.data) throw new Error(response)
      if (response.data) {
        setDataNextPlan(handleMapDataVesselTraffic(response.data.next_plan, 'next_plan'))
        setDataOngoingVessel(handleMapDataVesselTraffic(response.data.ongoing, 'ongoing_vessel'))
        setIsLoading(false)
      }
    } catch (error) {
      console.log('Error fetching vessel traffic information data:', String(error))
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchVesselTrafficData()
  }, [Location])

  useEffect(() => {
    const intervalId = setInterval(()=>{
      fetchVesselTrafficData()
    }, refreshInterval * 60 * 1000)
    return () => clearInterval(intervalId)
  }, [refreshInterval])

  return {
    data: {
      appHeight,
      isLoading,
      currentDate,
      dataNextPlan,
      dataOngoingVessel,
    },
    methods: {
      handleSetLocation,
    }
  }
}

export default useHooks